import VpnActif  from "../assets/icons/vpnActif.svg";
import VpnInActif  from "../assets/icons/vpnInActif.svg";
import { If } from "./If";

export interface VpnStatusProps {
	isVpnActif: boolean;
}

export const VpnStatus = ({ isVpnActif = false }: VpnStatusProps) => {
	return (
		<>
			<If condition={isVpnActif}>
				<VpnActif />
			</If>
			<If condition={!isVpnActif}>
				<VpnInActif />
			</If>
		</>
	);
};
